/*! @azure/msal-browser v2.26.0 2022-06-13 */
'use strict';
/* eslint-disable header/header */
var name = "@azure/msal-browser";
var version = "2.26.0";

export { name, version };
//# sourceMappingURL=packageMetadata.js.map
